<template>
	<svg
		width="44"
		height="44"
		viewBox="0 0 44 44"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="44" height="44" rx="12" fill="#FAFAFA" />
		<path
			d="M13.2453 13.2527L30.7469 30.7544M30.7469 13.2456L13.2453 30.7473"
			stroke="#9D9E9E"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
